// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"510":"5446123a","658":"09612be2","995":"e538a600"}[chunkId] + ".css";
};